import React from "react";

export default function Icons_Home() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Icons_Home</h2>
      <p>shnish gadha hai</p>
    </div>
  );
}
